import { render, staticRenderFns } from "./custom-input.vue?vue&type=template&id=1aa20141&scoped=true"
import script from "./custom-input.vue?vue&type=script&lang=js"
export * from "./custom-input.vue?vue&type=script&lang=js"
import style0 from "./custom-input.vue?vue&type=style&index=0&id=1aa20141&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa20141",
  null
  
)

export default component.exports